import {Dispatch} from "redux";

import {catch404} from "@pg-mono/request";
import {createRequestActionTypes, IAction} from "@pg-mono/request-state";

import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {getApplicationVendorDetailById} from "../api/get_application_vendor_detail_by_id";

const APPLICATION_VENDOR_DETAIL_PREFIX = "desktop/application/vendor_detail/fetch";
export const getApplicationVendorDetailTypes = createRequestActionTypes(APPLICATION_VENDOR_DETAIL_PREFIX);

export enum VendorOfficeType {
    HEADQUARTER = 1,
    REGIONAL_OFFICE = 2
}

export const getApplicationVendorDetail =
    (vendorId: number, applicationId: string) =>
    (dispatch: Dispatch): Promise<IVendorDetailApplication | void> => {
        dispatch({type: getApplicationVendorDetailTypes.start, id: applicationId});

        return getApplicationVendorDetailById(vendorId)
            .then((json) => {
                dispatch({type: getApplicationVendorDetailTypes.success, id: applicationId, result: json});
                return json;
            })
            .catch(
                catch404(() => {
                    dispatch({type: getApplicationVendorDetailTypes.error, id: applicationId}); // TODO: Obsluga
                })
            );
    };

export const resetApplicationVendorDetail = (): IAction => ({type: getApplicationVendorDetailTypes.reset});
import {Dispatch} from "redux";

import {catch404} from "@pg-mono/request";
import {createRequestActionTypes, IAction} from "@pg-mono/request-state";

import {IVendorDetailApplication} from "../../vendor/types/IVendorDetailApplication";
import {getApplicationVendorDetailById} from "../api/get_application_vendor_detail_by_id";

const APPLICATION_VENDOR_DETAIL_PREFIX = "desktop/application/vendor_detail/fetch";
export const getApplicationVendorDetailTypes = createRequestActionTypes(APPLICATION_VENDOR_DETAIL_PREFIX);

export enum VendorOfficeType {
    HEADQUARTER = 1,
    REGIONAL_OFFICE = 2
}

export const getApplicationVendorDetail =
    (vendorId: number, applicationId: string) =>
    (dispatch: Dispatch): Promise<IVendorDetailApplication | void> => {
        dispatch({type: getApplicationVendorDetailTypes.start, id: applicationId});

        return getApplicationVendorDetailById(vendorId)
            .then((json) => {
                dispatch({type: getApplicationVendorDetailTypes.success, id: applicationId, result: json});
                return json;
            })
            .catch(
                catch404(() => {
                    dispatch({type: getApplicationVendorDetailTypes.error, id: applicationId}); // TODO: Obsluga
                })
            );
    };

export const resetApplicationVendorDetail = (): IAction => ({type: getApplicationVendorDetailTypes.reset});
